import styled from "styled-components";

export const UsersPageContainer = styled.div`
  padding-inline: 28px;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

